import { render, staticRenderFns } from "./FeatureItem.vue?vue&type=template&id=b39df950&scoped=true"
import script from "./FeatureItem.vue?vue&type=script&lang=js"
export * from "./FeatureItem.vue?vue&type=script&lang=js"
import style0 from "./FeatureItem.vue?vue&type=style&index=0&id=b39df950&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39df950",
  null
  
)

export default component.exports